export default __webpack_public_path__ + "static/media/2give.84362bf5.svg";